import React from "react";

const SectionHeading = ({
  eyebrow,
  headline,
  subheading,
  centered = true,
  headingLevel = 2,
  headingId,
}) => {
  const HeadingTag = `h${headingLevel}`;

  return (
    <header className={centered ? "landing-v2__section-header landing-v2__section-header--center" : "landing-v2__section-header"}>
      {eyebrow ? <p className="landing-v2__eyebrow">{eyebrow}</p> : null}
      <HeadingTag
        id={headingId}
        className={`landing-v2__heading ${centered ? "landing-v2__heading--center" : ""}`}
      >
        {headline}
      </HeadingTag>
      {subheading ? (
        <p className={`landing-v2__subheading ${centered ? "landing-v2__subheading--center" : ""}`}>
          {subheading}
        </p>
      ) : null}
    </header>
  );
};

export default SectionHeading;
